module.exports = __webpack_public_path__ + "img/realms-logo.749ae1aa.png";